/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect } from "react";
import { ReadingTimerCount } from "../components/timer/readingtimeCount";
import { AudioUrl } from "../../libs/env";
const SpeakRead = ({
  exercise,
  isReview,
  isStopTimer,
  setIsStopTimer,
  section_id,
  data,
  playbeepaudio,
  isAudioUpload,
  creatQuizDataAndSubmit,
  setIsaudioUpload,
  setstartReadingtime,
  startReadingtime,
  hasUserInteracted
}) => {
  const [saveOnTimeOver, SetSaveOnTimeOver] = useState(false);
  const audioRef = useRef(null);

  const playAudio = async () => {
    if (audioRef.current) {
      try {
        await audioRef.current.play();
        audioRef.current.onended = () => {
          audioRef.current.src = "";
          setTimeout(() => {
            playbeepaudio();
            setstartReadingtime(true);
          }, 150);
        };
      } catch (error) {
        if (error.name === 'NotAllowedError' && !hasUserInteracted) {
          alert("Please click anywhere on the page to enable audio playback.");
        } else {
          setstartReadingtime(true);
          console.error("Error playing audio:", error);
        }
      }
    }
  };

  useEffect(() => {
    if(!window.sessionStorage.getItem("readingtimer" + data.student_assessment_id + section_id + exercise.id))
    {
      playAudio();
    }
    else{
      setstartReadingtime(true);
    }
  }, [data, section_id, exercise, hasUserInteracted]);

  return (
    <>
      <div key={exercise.id}>
        {startReadingtime ? (
          <ReadingTimerCount
            isStopTimer={isReview ? true : isStopTimer}
            data={data}
            data_section_id={section_id}
            data_exercise_id={exercise.id}
            // setShowTimeWarning={setShowTimeWarning}
            totalTimeInSeconds={exercise.speaking_response_time}
            onStop={(props) => {
              if (!saveOnTimeOver) {
                setIsStopTimer(true);
                SetSaveOnTimeOver(true);
                playbeepaudio();
                creatQuizDataAndSubmit(); 
              }
              else if(isAudioUpload)
              {
                setIsaudioUpload(false);
              }
            }}
          />
        ) : (
          <audio
            ref={audioRef}
            src={
              exercise.response_audio
                ? exercise.response_audio
                : `${AudioUrl}/reading_audio.mp3`
            }
            playsInline={true}
          />
        )}

      </div>
    </>
  );
};

export default SpeakRead;
